var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManualEntry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M20.6 5.5h25c4.418 0 8 3.582 8 8v32c0 4.418-3.582 8-8 8h-32c-4.418 0-8-3.582-8-8v-27",
    transform: "translate(-20 -719) translate(22 721)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.1 24.644l4.645 4.3 1.355.423V47.15h-6V24.644zM27.1 31.052l4.546.448H33.1v15.65h-6V31.052z",
    transform: "translate(-20 -719) translate(22 721)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.1 11v20.5h-6v-3.099l1.989-1.995L31.698 11H33.1z",
    transform: "translate(-20 -719) translate(22 721) matrix(1 0 0 -1 0 42.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.1 30.09l2 .334v16.725h-2V30.09zM45.1 11H47.1V47.149H45.1zM36.1 11H42.1V47.149H36.1z",
    transform: "translate(-20 -719) translate(22 721)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M26.511 17.42l2.29 11.222-11.342-2.17L.254 9.268c-.356-.357-.321-.705.003-1.599 0 0 .549-1.942 3.067-4.459C5.841.693 7.709.217 7.709.217c.636-.229 1.257-.343 1.599-.003L26.51 17.42zM17.458 26.472s1.32-7.047 9.053-9.052M2.083 11.097s2.732-5.635 9.053-9.054M23.625 27.625s.562-2.957 4-4",
    transform: "translate(-20 -719) translate(22 721)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualEntry);
export default __webpack_public_path__ + "static/media/manual-entry.28825d71.svg";
export { ForwardRef as ReactComponent };